import dayjs from 'v2/utils/dayjs'
import { FLOW_RUN_LOGS_EXPIRY_DAYS } from '../constants'

export const isFlowRunLogsExpired = (endedAt: number | undefined) => {
  if (!endedAt) return false
  return dayjs().diff(dayjs(endedAt * 1000), 'day', true) > FLOW_RUN_LOGS_EXPIRY_DAYS
}
